import { IProductPromotionsData } from "../ProductDetails/AddToCart/interfaces";

export const PRODUCT_LAYOUT_STALE_TIME = 5 * 60 * 1000; // 5 minutes

export const EMPTY_PRODUCT_PROMO_DATA: IProductPromotionsData = {
  productPromotions: [],
  nonFashionWeekPromos: [],
  marketPromo: undefined,
  promotionStyleBanners: [],
  nonPromotionStyleBanners: [],
};
